import {Validator} from '@/type/validation/result';
import {年月書式, 必須入力} from '@/type/validation/validator';

export interface 入出庫照会在庫場所型 {
  部署コード: string;
  部署名: string;
}

export interface 入出庫照会絞込条件型 {
  在庫場所: string;
  在庫年月: string;
}

export interface 入出庫照会依頼型 {
  在庫場所: string;
  在庫年月: string;
}

export interface 入出庫照会項目別金額明細型 {
  内服薬: number;
  注射薬: number;
  外用薬: number;
  歯科用薬: number;
  その他: number;
  医薬品以外: number;
  卸返品: number;
  合計: number;
}

export interface 入出庫照会入出庫先別明細型 {
  入出庫先名: string;
  金額明細: 入出庫照会項目別金額明細型;
}

export interface 入出庫照会結果型 {
  前月末残: 入出庫照会項目別金額明細型;

  卸入庫返品一覧: 入出庫照会入出庫先別明細型[];
  部署入庫一覧: 入出庫照会入出庫先別明細型[];
  譲受一覧: 入出庫照会入出庫先別明細型[];
  棚卸調整入庫: 入出庫照会項目別金額明細型;
  当月入庫高: 入出庫照会項目別金額明細型;

  部署移動一覧: 入出庫照会入出庫先別明細型[];
  譲渡一覧: 入出庫照会入出庫先別明細型[];
  払出: 入出庫照会項目別金額明細型;
  破棄破損: 入出庫照会項目別金額明細型;
  棚卸調整出庫: 入出庫照会項目別金額明細型;
  在庫調整: 入出庫照会項目別金額明細型;
  当月出庫高: 入出庫照会項目別金額明細型;

  当月総残高: 入出庫照会項目別金額明細型;
}

export const 入出庫集計取得依頼型バリデータ一覧: Validator[] = [
  {
    name: '在庫年月',
    constraints: [
      {method: 必須入力, message: '在庫年月は必須です'},
      {method: 年月書式, message: '在庫年月の書式が不正です'},
    ],
  },
];
